var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg79(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M46.77,15.93c-1.5-1.79-4.18-4.27-7.58-4.33c-2.03-0.05-4.16,0.59-6.07,1.71c-2.41-1.09-5.17-1.7-8.08-1.71l0,0 c-0.02,0-0.03,0-0.05,0c-0.01,0-0.02,0-0.03,0c0,0-0.01,0-0.01,0v0c-0.31,0-1.49,0-1.79,0v0c-0.01,0-0.01,0-0.01,0 c-0.01,0-0.02,0-0.03,0c-0.02,0-0.03,0-0.05,0l0,0c-2.91,0.01-5.66,0.62-8.08,1.71c-1.91-1.13-4.03-1.76-6.07-1.71 c-3.4,0.06-6.08,2.54-7.58,4.33c-0.75,0.89-0.54,2.23,0.45,2.84l0.03,0.02c0.79,0.49,1.83,0.33,2.43-0.38 c1.12-1.34,2.91-2.96,4.74-3c0.58-0.03,1.33,0.07,2.13,0.32c-0.36,0.31-0.71,0.62-1.03,0.96c-2.79,2.91-4.15,6.87-3.94,11.46 c0.52,11.31,6.75,11.9,7.99,11.9h0.01c1.24,0,7.47-0.59,7.99-11.9c0.27-5.99-1.79-9.79-3.77-12.04c1.5-0.45,3.11-0.7,4.77-0.7 c0.31-0.01,1.51-0.01,1.83,0c1.66,0,3.28,0.25,4.77,0.7c-1.98,2.25-4.05,6.04-3.77,12.04c0.52,11.31,6.75,11.9,7.99,11.9h0.01 c1.24,0,7.47-0.59,7.99-11.9c0.21-4.58-1.15-8.54-3.94-11.46c-0.32-0.34-0.67-0.65-1.03-0.96c0.81-0.25,1.55-0.35,2.13-0.32 c1.83,0.03,3.62,1.66,4.74,3c0.6,0.71,1.63,0.87,2.43,0.38l0.03-0.02C47.31,18.17,47.52,16.83,46.77,15.93z M14.15,36.24 c-1.84-0.01-3.9-2.18-4.18-8.26c-0.16-3.56,0.81-6.47,2.88-8.64c0.54-0.56,1.16-1.07,1.84-1.52c0.16,0.14,0.31,0.27,0.46,0.43 c1.58,1.62,3.4,4.62,3.17,9.73C18.05,34.06,15.99,36.23,14.15,36.24z M38.14,27.98c-0.28,6.07-2.34,8.25-4.18,8.26 c-1.84-0.01-3.9-2.18-4.18-8.26c-0.23-5.11,1.59-8.11,3.17-9.73c0.15-0.15,0.31-0.29,0.46-0.43c0.68,0.45,1.3,0.96,1.84,1.52 C37.34,21.51,38.31,24.42,38.14,27.98z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg79);
export default __webpack_public_path__ + "static/media/79.399be242f5f72dec5a67bf2e8ef11d01.svg";
export { ForwardRef as ReactComponent };